import React, { useState } from "react";

const CATEGORIES = [
  {
    title: "Arrays & Hashing",
    icon: "📦",
    questions: [
      { id: 1, title: "Two Sum", difficulty: "Easy", companies: ["Google", "Amazon", "Apple"], link: "https://leetcode.com/problems/two-sum/" },
      { id: 2, title: "Valid Anagram", difficulty: "Easy", companies: ["Google", "Meta"], link: "https://leetcode.com/problems/valid-anagram/" },
      { id: 3, title: "Group Anagrams", difficulty: "Medium", companies: ["Amazon", "Uber"], link: "https://leetcode.com/problems/group-anagrams/" },
      { id: 4, title: "Top K Frequent Elements", difficulty: "Medium", companies: ["Microsoft", "LinkedIn"], link: "https://leetcode.com/problems/top-k-frequent-elements/" }
    ]
  },
  {
    title: "Two Pointers & Sliding Window",
    icon: "🪟",
    questions: [
      { id: 5, title: "Valid Palindrome", difficulty: "Easy", companies: ["Meta", "Apple"], link: "https://leetcode.com/problems/valid-palindrome/" },
      { id: 6, title: "3Sum", difficulty: "Medium", companies: ["Google", "Amazon"], link: "https://leetcode.com/problems/3sum/" },
      { id: 7, title: "Container With Most Water", difficulty: "Medium", companies: ["Google", "Meta"], link: "https://leetcode.com/problems/container-with-most-water/" },
      { id: 8, title: "Longest Substring Without Repeating Characters", difficulty: "Medium", companies: ["Uber", "Bloomberg"], link: "https://leetcode.com/problems/longest-substring-without-repeating-characters/" }
    ]
  },
  {
    title: "Trees & Graphs",
    icon: "🌳",
    questions: [
      { id: 9, title: "Invert Binary Tree", difficulty: "Easy", companies: ["Google", "Netflix"], link: "https://leetcode.com/problems/invert-binary-tree/" },
      { id: 10, title: "Validate Binary Search Tree", difficulty: "Medium", companies: ["Microsoft", "Oracle"], link: "https://leetcode.com/problems/validate-binary-search-tree/" },
      { id: 11, title: "Number of Islands", difficulty: "Medium", companies: ["Amazon", "LinkedIn"], link: "https://leetcode.com/problems/number-of-islands/" },
      { id: 12, title: "Pacifc Atlantic Water Flow", difficulty: "Medium", companies: ["Google", "Meta"], link: "https://leetcode.com/problems/pacific-atlantic-water-flow/" }
    ]
  },
  {
    title: "Dynamic Programming",
    icon: "🧠",
    questions: [
      { id: 13, title: "Climbing Stairs", difficulty: "Easy", companies: ["Amazon", "Google"], link: "https://leetcode.com/problems/climbing-stairs/" },
      { id: 14, title: "Coin Change", difficulty: "Medium", companies: ["Uber", "Airbnb"], link: "https://leetcode.com/problems/coin-change/" },
      { id: 15, title: "Longest Increasing Subsequence", difficulty: "Medium", companies: ["Microsoft", "Google"], link: "https://leetcode.com/problems/longest-increasing-subsequence/" },
      { id: 16, title: "Word Break", difficulty: "Medium", companies: ["Meta", "Amazon"], link: "https://leetcode.com/problems/word-break/" }
    ]
  }
];

export default function Coding() {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const stats = {
    total: CATEGORIES.reduce((acc, cat) => acc + cat.questions.length, 0),
    completed: 0, // Placeholder for future state
  };

  return (
    <div className="fade-in" style={{ paddingBottom: 40 }}>
      {/* Header Section */}
      <div style={{ marginBottom: 32 }}>
        <h1 className="page-title">Coding Mastery</h1>
        <p className="page-sub">Top DSA questions curated for cracking MANG/FAANG interviews.</p>
        
        <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
          <div className="card" style={{ flex: 1, padding: "16px 20px", display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{ fontSize: 32 }}>🎯</div>
            <div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "var(--blue)" }}>{stats.total}</div>
              <div style={{ fontSize: 12, color: "var(--text-muted)" }}>Curated Problems</div>
            </div>
          </div>
          <div className="card" style={{ flex: 1, padding: "16px 20px", display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{ fontSize: 32 }}>👑</div>
            <div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "var(--green)" }}>100%</div>
              <div style={{ fontSize: 12, color: "var(--text-muted)" }}>Target Efficiency</div>
            </div>
          </div>
          <div className="card" style={{ flex: 1, padding: "16px 20px", display: "flex", alignItems: "center", gap: 16 }}>
            <div style={{ fontSize: 32 }}>💼</div>
            <div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "var(--amber)" }}>MANG</div>
              <div style={{ fontSize: 12, color: "var(--text-muted)" }}>Optimized for FAANG</div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Roadmap */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))", gap: 24 }}>
        {CATEGORIES.map((cat, idx) => (
          <div key={idx} className="card" style={{ padding: 0, overflow: "hidden" }}>
            <div style={{ 
              padding: "16px 20px", 
              background: "var(--bg-soft)", 
              borderBottom: "1px solid var(--border-soft)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontSize: 20 }}>{cat.icon}</span>
                <span style={{ fontWeight: 700 }}>{cat.title}</span>
              </div>
              <span className="badge badge-blue">{cat.questions.length} Questions</span>
            </div>
            
            <div style={{ padding: "8px 0" }}>
              {cat.questions.map((q) => (
                <a 
                  key={q.id} 
                  href={q.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="list-item"
                  style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center",
                    padding: "12px 20px",
                    textDecoration: "none",
                    transition: "background 0.2s"
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, color: "var(--text-primary)", marginBottom: 4 }}>{q.title}</div>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                      {q.companies.map((company, cIdx) => (
                        <span key={cIdx} style={{ fontSize: 10, color: "var(--text-muted)", padding: "2px 6px", background: "var(--bg)", borderRadius: 4 }}>
                          {company}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <span className={`tag ${q.difficulty === "Easy" ? "tag-easy" : q.difficulty === "Medium" ? "tag-medium" : "tag-hard"}`}>
                      {q.difficulty}
                    </span>
                    <span style={{ fontSize: 14, color: "var(--text-muted)" }}>🔗</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .list-item:hover {
          background: var(--bg-hover);
        }
        .list-item:not(:last-child) {
          border-bottom: 1px solid var(--border-soft);
        }
      `}</style>
    </div>
  );
}
